// полифилы для инвалидов
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

if (!Array.from) {
    Array.from = function (object) {
        'use strict';
        return [].slice.call(object);
    };
}

window.requestAnimationFrame = window.requestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || window.msRequestAnimationFrame
    || function (f) {
        return setTimeout(f, 1000 / 60)
    };

window.cancelAnimationFrame = window.cancelAnimationFrame
    || window.mozCancelAnimationFrame
    || function (requestID) {
        clearTimeout(requestID)
    };

$(function () {
    var timeline = document.querySelector('.timeline');
    if(!timeline) {
        return;
    }
    var dots = timeline.querySelectorAll('.timeline__dot'),
        progress_line = timeline.querySelector('.timeline__dots_progress'),
        section_counts = dots.length - 1,
        max_width = 98,
        width_per_section = max_width / section_counts,
        colored_class = 'timeline__dot--colored',
        next_button = timeline.querySelector('.timeline__btn--next'),
        prev_button = timeline.querySelector('.timeline__btn--prev'),
        slider = $('.slider'),
        animate_on = true,
        requestframeref = null
        ;

    slider.slick({
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        pauseOnDotsHover: true,
        pauseOnHover: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    dots: true
                }
            }
        ]
    });

    function animate(option) {
        var start = window.performance.now(),
            delay = 0;
        requestframeref = requestAnimationFrame(function renderStep(time) {
            var timeFraction = 0;
            if (animate_on) {
                timeFraction = (time - start) / (option.duration + delay);
                var progress = option.timing(timeFraction > 1 ? 1 : timeFraction);
                option.draw(progress);
            } else {
                delay = time - start;
            }
            if (timeFraction < 1) {
                requestframeref = requestAnimationFrame(renderStep);
            }
        });
    }

    function startAnimateProgress(startWidth, stopWidth, duration, reverse) {
        var delta = Math.abs(startWidth - stopWidth);
        animate({
            duration: duration,
            timing: function (timeFraction) {
                return timeFraction;
            },
            draw: function (progress) {
                var width = 0;
                if (reverse) {
                    width = stopWidth - (progress * delta);
                } else {
                    width = startWidth + (progress * delta);
                }
                progress_line.style.width = width + '%';
            }
        });
    }

    function renderProgress(curSlide, reverse) {
        document.querySelectorAll('.' + colored_class).forEach(function (item) {
            item.classList.remove(colored_class);
        });
        Array.from(dots).slice(0, curSlide + 1).map(function (item) {
            item.classList.add(colored_class);
        });
        if (curSlide === 0) {
            prev_button.classList.add('timeline__btn--disabled');
        } else {
            prev_button.classList.remove('timeline__btn--disabled');
        }
        if (curSlide === dots.length - 1) {
            next_button.classList.add('timeline__btn--disabled');
            slider.slick('slickPause');
            slider.slick('slickSetOption', 'autoplay', false);
        } else {
            next_button.classList.remove('timeline__btn--disabled');
        }
        var width = width_per_section * curSlide;
        progress_line.style.width = width + '%';
        if (width < max_width) {
            startAnimateProgress(width, reverse ? width + width_per_section : width - width_per_section, 2100, reverse);
        } else {
            setTimeout(function () {
                slider.slick('slickSetOption', 'autoplay', true);
                slider.slick('slickGoTo', 0);
                slider.slick('slickPlay');
            }, 5000);
        }
    }

    function stopAnimationProgress() {
        cancelAnimationFrame(requestframeref);
    }

    slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        stopAnimationProgress();
        renderProgress(nextSlide, currentSlide > nextSlide);
    });
    renderProgress(0);

    dots.forEach(function (item, i) {
        item.addEventListener('click', function (e) {
            e.preventDefault();
            slider.slick('slickGoTo', i);
        })
    });

    next_button.addEventListener('click', function (e) {
        e.preventDefault();
        slider.slick('slickNext');
    });

    prev_button.addEventListener('click', function (e) {
        e.preventDefault();
        slider.slick('slickPrev');
    });

    timeline.parentElement.addEventListener('mouseenter', function () {
        console.log('enter');
        slider.slick('slickPause');
        animate_on = false;
    }, false);

    timeline.parentElement.addEventListener('mouseleave', function () {
        console.log('leave');
        slider.slick('slickPlay');
        animate_on = true;
    }, false);
});
